import React, { memo } from 'react';
import SelectiveListItemBase from './SelectiveListItem.base';
const SelectiveListItem = ({ state, onPress, ...props }) => {
    return (React.createElement(SelectiveListItemBase, { state: state, onPress: onPress, ...props }));
};
export default memo(SelectiveListItem);
export { SelectiveListItem };
